import { SupportedPaymentMethods } from '../constants';
import { PaymentMethodsType } from '../@types';

import {
  AffirmForm,
  BankForm,
  CreditCardForm,
  OxxoForm,
  PayPalForm,
  GooglePayForm,
} from './payment-methods';
import {
  CardMethodIcon,
  BankMethodIcon,
  PaypalMethodIcon,
  OxxoMethodIcon,
  AffirmMethodIcon,
  ApplePayMethodIcon,
  GooglePayMethodIcon,
} from './ui-elements/MethodIcon';

export const PaymentMethodRegistry = {
  [SupportedPaymentMethods.CARD]: {
    Title: 'Cards',
    Component: CreditCardForm,
    Icon: CardMethodIcon,
  },
  [SupportedPaymentMethods.PAYPAL]: {
    Title: 'Paypal',
    Component: PayPalForm,
    Icon: PaypalMethodIcon,
  },
  [SupportedPaymentMethods.BANK]: {
    Title: 'Bank Transfer',
    Component: BankForm,
    Icon: BankMethodIcon,
  },
  [SupportedPaymentMethods.OXXO]: {
    Title: 'OXXO',
    Component: OxxoForm,
    Icon: OxxoMethodIcon,
  },
  [SupportedPaymentMethods.AFFIRM]: {
    Title: 'Affirm',
    Component: AffirmForm,
    Icon: AffirmMethodIcon,
  },
  [SupportedPaymentMethods.APPLEPAY]: {
    Title: 'Apple Pay',
    Component: GooglePayForm,
    Icon: ApplePayMethodIcon,
    hasAmount: true,
  },
  [SupportedPaymentMethods.GOOGLEPAY]: {
    Title: 'Google Pay',
    Component: GooglePayForm,
    Icon: GooglePayMethodIcon,
    hasAmount: true,
  },
};

export type PaymentMethodRegistryType = Record<PaymentMethodsType, {
  Title: string,
  Component: JSX.Element,
  Icon: JSX.Element,
}>;
